import React from "react";
import { ListTeachers } from "../../Components/Teachers/ListTeachers";
import Wrapper from "../../Components/Wrapper/wrapper";

export const TeachersList = () => {
  return (
    <Wrapper header="Teachers">
      <ListTeachers />
    </Wrapper>
  );
};
